import { translate } from '@util/Localization';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../config/Color';
import { appOverride } from '../util/AppUtils';
import * as images from './assets/Images';
import * as logos from './assets/images/Logos';
import { ProminentContainer } from './styles/Containers';
import { SmallText } from './styles/StepList';

export const DrPetersCard: FunctionComponent = () => {
  const description = [
    'Clinical Psychophysiologist',
    'Gut-Directed Hypnotherapist',
    'World-Leading Researcher',
  ];

  return appOverride({
    nerva: (
      <MedicalDoctorCard>
        <img
          src={images.drPetersCredentials}
          alt="Dr. Simone Peters"
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
        <MedicalDescriptionContainer>
          {description.map((credential, index) => (
            <SmallText key={index}>• {credential}</SmallText>
          ))}
        </MedicalDescriptionContainer>
      </MedicalDoctorCard>
    ),
    default: (
      <DoctorCard
        description={description}
        logos={[
          {
            src: images.monashMindGutLogos,
            alt: 'Monash University and Mind Gut clinic logos',
            width: 140,
          },
        ]}
        doctorImage={images.simonePeters2024}
        hasDropShadow={false}
      />
    ),
  });
};

export const DrElkinsCard: FunctionComponent = () => (
  <DoctorCard
    description={['World-leading Professor of Psychology and Neuroscience']}
    logos={[{ alt: 'Baylor University', src: logos.baylor }]}
    doctorImage={images.drGary}
    hasDropShadow
  />
);

type Props = {
  description: string[];
  logos: { alt: string; src: string; width?: number }[];
  doctorImage: string;
  hasDropShadow: boolean;
};

export const DoctorCard: FunctionComponent<Props> = (props) => (
  <CreatorContainer hasDropShadow={props.hasDropShadow} data-test="CreatorContainer">
    <CertificateSection>
      <CertificateContainer>
        <img src={props.doctorImage} alt={translate('doctorShort')} width={52} height={52} />
      </CertificateContainer>
      <div>
        <SmallText boldFontWeight>{translate('doctor')}</SmallText>
        {props.description.map((credential, index) => (
          <SmallText key={index}>• {credential}</SmallText>
        ))}
        <LogoContainer>
          {props.logos.map((data, index) => (
            <img key={index} alt={data.alt} src={data.src} width={data.width ?? 85} />
          ))}
        </LogoContainer>
      </div>
    </CertificateSection>
  </CreatorContainer>
);

const CreatorContainer = styled(ProminentContainer)<{ hasDropShadow: boolean }>`
  box-shadow: ${({ hasDropShadow, theme }) => (hasDropShadow ? theme.shadow.drop.gray : 'none')};
  border-radius: ${({ theme }) => theme.spacing._22px};
  padding: ${({ theme }) => theme.spacing._10px};
  background: ${Color.subscription.accent};
`;

const LogoContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing._10px};

  img {
    margin-right: ${({ theme }) => theme.spacing._16px};
  }
`;

const CertificateSection = styled.div`
  display: flex;
  margin: ${({ theme }) => theme.spacing._16px} 0;
`;

const CertificateContainer = styled.div`
  position: relative;
  margin-right: ${({ theme }) => theme.spacing._12px};
`;

const MedicalDoctorCard = styled.div`
  width: 100%;
  margin: ${({ theme }) => theme.spacing._16px} 0;
  /* No background, no shadow - just the image */
`;

const MedicalDescriptionContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing._16px};
`;
